export default function isWebOnlyApp(appType: string) {
  return appType === 'com.sap.project.buildapps.web';
}
